/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Col_PhoneInputs */

const vi_cdo_col_phone = /** @type {(inputs: Cdo_Col_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SĐT`)
};

/**

* @param {Cdo_Col_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_col_phone = /** @type {((inputs?: Cdo_Col_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Col_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_col_phone(inputs)
});